type SeriesDatum = Record<string, string | number | Date>

// A stacked workspace series carries one numeric key per workspace next to its
// bucket metadata, so the headline total is every numeric cell added up.
export const sumWorkspaceSeries = (
	data: readonly SeriesDatum[] | undefined,
): number | null => {
	if (!data) return null
	let total = 0
	for (const bucket of data) {
		for (const [key, value] of Object.entries(bucket)) {
			if (key === "bucket" || key === "createdAt") continue
			if (typeof value === "number") total += value
		}
	}
	return Math.round(total * 100) / 100
}
